export enum UserTeam {
  Tools = 'Tools',
  Risk = 'Risk'
}

export enum ToolsUserRole {
  Admin = 'Admin'
}

export enum RiskUserRole {
  Admin = 'Admin',
  ShiftManager = 'Shift manager',
  Compliance = 'Compliance',
  ComplianceExternal = 'Compliance external',
  Senior = 'Senior',
  Specialist = 'Specialist',
  Junior = 'Junior',
  Trainee = 'Trainee',
  DataAnalyst = 'Data analyst',
  KYCExternal = 'KYC external',
  Infra = 'Infra',
  Sanctions = 'Sanctions'
}
